import { Route } from "react-router-dom";

import Plants from "./components/masterData/plants/Plants";
import PlantEdit from "./components/masterData/plants/PlantEdit";

import LineGroups from "./components/masterData/lineGroups/LineGroups";
import LineGroupCreate from "./components/masterData/lineGroups/LineGroupCreate";
import LineGroupEdit from "./components/masterData/lineGroups/LineGroupEdit";
import LineGroupMatrix from "./components/masterData/lineGroups/LineGroupMatrix";

import Lines from "./components/masterData/lines/Lines";
import LineCreate from "./components/masterData/lines/LineCreate";
import LineEdit from "./components/masterData/lines/LineEdit";
import LineKanbanEdit from "./components/masterData/lines/LineKanban";

import Evaluation from "./components/models/Evaluation";
import Models from "./components/models/details/Models";
import ModelsStaging from "./components/models/staging/ModelsStaging";

import MaterialParallelCreate from "./components/masterData/materials/MaterialParallelCreate";
import MaterialParallelEdit from "./components/masterData/materials/MaterialParallelEdit";
import MaterialEdit from "./components/masterData/materials/MaterialEdit";
import MaterialPlantEdit from "./components/masterData/materials/MaterialPlantEdit";

import Processes from "./components/masterData/processes/Processes";

import People from "./components/masterData/people/People";
import PeopleCreate from "./components/masterData/people/PeopleCreate";
import PeopleEdit from "./components/masterData/people/PeopleEdit";
import PeopleDetailsStandalone from "./components/masterData/people/PeopleDetailsStandalone";

import BatchopGroups from "./components/masterData/batchopGroups/BatchopGroups";
import BatchopGroupCreate from "./components/masterData/batchopGroups/BatchopGroupCreate";
import BatchopGroupEdit from "./components/masterData/batchopGroups/BatchopGroupEdit";
import BatchopLocations from "./components/masterData/batchopLocations/BatchopLocations";
import BatchopLocationCreate from "./components/masterData/batchopLocations/BatchopLocationCreate";
import BatchopLocationEdit from "./components/masterData/batchopLocations/BatchopLocationEdit";

import StockLocations from "./components/masterData/stockLocations/StockLocations";
import StockLocationEdit from "./components/masterData/stockLocations/StockLocationEdit";

import Categories from "./components/masterData/categories/Categories";
import CategoryCreate from "./components/masterData/categories/CategoryCreate";

import OrganisationEdit from "./components/masterData/OrganisationEdit";
import Electricity from "./components/eletricity/Electricity";

import Materials from "./components/masterData/materials/Materials";
import Operations from "./components/productionData/Operations";
import Productions from "./components/productionData/Productions";

export const getRoutes = ({ match: { url } }: { match: { url: string } }) => (
    <>
        <Route path={url} component={Plants} exact />
        <Route path={`${url}/resources/plants/:uuid?`} component={Plants} />
        <Route path={`${url}/resources/line_groups/:uuid?`} component={LineGroups} />
        <Route path={`${url}/resources/line_group/create`} component={LineGroupCreate} />
        <Route path={`${url}/resources/line_group/edit/:uuid`} component={LineGroupEdit} />
        <Route path={`${url}/resources/line_group/matrix/:uuid`} component={LineGroupMatrix} />
        <Route path={`${url}/resources/lines/:uuid?`} component={Lines} />
        <Route path={`${url}/resources/line/create`} component={LineCreate} />
        <Route path={`${url}/resources/line/edit/:uuid`} component={LineEdit} />
        <Route path={`${url}/resources/line/kanban/:uuid`} component={LineKanbanEdit} />
        <Route path={`${url}/resources/materials/:uuid?`} component={Materials} />
        <Route path={`${url}/resources/material/create`} component={MaterialParallelCreate} />
        <Route path={`${url}/resources/material_parallel/edit/:uuid?`} component={MaterialParallelEdit} />
        <Route path={`${url}/resources/material/edit/:uuid?`} component={MaterialEdit} />
        <Route
            path={`${url}/resources/material_plant/edit/:material_uuid/:plant_uuid?`}
            component={MaterialPlantEdit}
        />
        <Route path={`${url}/resources/plant/edit/:uuid?`} component={PlantEdit} />
        <Route path={`${url}/resources/processes/:uuid?`} component={Processes} />
        <Route path={`${url}/resources/people/:uuid?`} component={People} />
        <Route path={`${url}/resources/person/edit/:uuid`} component={PeopleEdit} />
        <Route path={`${url}/resources/person/create`} component={PeopleCreate} />
        <Route path={`${url}/resources/person/view/:uuid`} component={PeopleDetailsStandalone} />
        <Route path={`${url}/resources/batchop_groups/:uuid?`} component={BatchopGroups} />
        <Route path={`${url}/resources/batchop_group/create`} component={BatchopGroupCreate} />
        <Route path={`${url}/resources/batchop_group/edit/:uuid`} component={BatchopGroupEdit} />
        <Route path={`${url}/resources/batchop_locations/:uuid?`} component={BatchopLocations} />
        <Route path={`${url}/resources/batchop_location/create`} component={BatchopLocationCreate} />
        <Route path={`${url}/resources/batchop_location/edit/:uuid`} component={BatchopLocationEdit} />
        <Route path={`${url}/resources/stock_locations/:uuid?`} component={StockLocations} />
        <Route path={`${url}/resources/categories/:id?`} component={Categories} />
        <Route path={`${url}/resources/category/create`} component={CategoryCreate} />
        <Route path={`${url}/resources/category/edit/:id`} component={CategoryCreate} />
        <Route path={`${url}/resources/stock_location/edit/:uuid?`} component={StockLocationEdit} />
        <Route path={`${url}/resources/organisation`} component={OrganisationEdit} />
        <Route path={`${url}/production-data/operations`} component={Operations} />
        <Route path={`${url}/production-data/productions`} component={Productions} />
        <Route path={`${url}/models`} component={Models} exact />
        <Route path={`${url}/models/eval`} component={Evaluation} />
        <Route path={`${url}/models/staging`} component={ModelsStaging} />
        <Route path={`${url}/models/search`} component={Models} />
        <Route path={`${url}/electricity`} component={Electricity} />
    </>
);
